import { Tab, Role } from '../const';

/**
 * @function makeEmptyRoles
 * @param { string } groupId
 * @returns { array }
 */
export function makeEmptyRoles(groupId) {
	const emptyRoles = [
		{
			[Role.GroupId]: groupId,
			[Role.Id]: '-2',
			[Role.Name]: '',
			[Role.Desc]: '',
			[Role.Type]: '',
			[Role.Checked]: false,
		},
	];

	return emptyRoles;
}

/**
 * @function makeEmptySubtabs
 * @param { string } groupId
 * @param { string } subtabId
 * @returns { array }
 */
export function makeEmptySubtabs(groupId, subtabId) {
	const emptySubtabs = [
		{
			[Tab.GroupId]: groupId,
			[Tab.Id]: '-2',
			[Tab.Name]: '',
			[Tab.Url]: '',
			[Tab.Desc]: '',
			[Tab.Order]: '',
			[Tab.SubtabId]: subtabId,
			[Tab.Checked]: false,
		},
	];

	return emptySubtabs;
}
